import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityFaqService} from '../../../shared/services/university-faq.service';
import {UniversityService} from '../../../shared/services/university.service';

@Component({
    selector: 'app-university-faq',
    templateUrl: './university-faq.component.html',
    styleUrls: ['./university-faq.component.scss']
})
export class UniversityFaqComponent implements OnInit {
    public question: any;
    public answer: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    faqs: any = [];
    submitting: any = false;
    university: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityFaqService: UniversityFaqService,
                private universityService: UniversityService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.get();
            }
        });
    }

    get() {
        this.universityFaqService.getByAdmin(this.universityId).subscribe(data => {
            this.faqs = (data && data.length > 0) ? data : [];
        });
    }

    addDetail() {
        const params = {
            question: this.question ? this.question : '',
            answer: this.answer ? this.answer : '',
            sort_order: this.faqs ? this.faqs.length : 0
        };
        this.submitting = true;
        this.universityFaqService.createByAdmin(this.universityId, params).subscribe(data => {
            this.submitting = false;
            this.question = undefined;
            this.answer = undefined;
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    delete(id) {
        this.universityFaqService.deleteByAdmin(this.universityId, id).subscribe(data => {
            this.get();
        });
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
